// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__30IOy","ranges":"BmiRanges_ranges__3YTeW"};